import axios from "axios";
import authHeader from "@/services/auth-header";
export async function getDocuSignFormInstanceToken(webformId) {
        console.log("Hi")
   let response = await axios.get(
        process.env.VUE_APP_HOST +
            "/api/docu-sign/webform/" +
            webformId +
            "/get",
        {
            headers: {
                "Content-Type": "application/json",
                ...authHeader(),
                "x-docusign-signature-1":"az+uBbZlJWdvjAdzI+xo7UOp4EBYmzoFk8Jt09LwfYc="
            },
        }

    ).catch(
        function (error) {
                console.log("Error",error);
                return null;
        }
    );
        return response.data;
}



